export { default as default } from './EditarBlocComponent.jsx';